export function draftForceSlotKey(eventId: string, slotId: number | undefined, slotLabel: string): string {
    return `${eventId}::${slotId ?? slotLabel}`;
}
